import { Injectable, inject } from '@angular/core';
import { AlertController } from '@ionic/angular';

// Services
import { TranslationService } from '../translation/translation.service';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private alertController = inject(AlertController);
  private translate = inject(TranslationService);

  async showAlert(
    header: string,
    message: string,
    _buttons: 'ok' | 'ok|cancel' = 'ok',
  ): Promise<HTMLIonAlertElement> | null {
    if (message) {
      const buttons = [
        {
          role: 'confirm',
          text: 'OK',
        },
      ];
      if (_buttons?.includes('cancel')) {
        buttons.push({
          role: 'cancel',
          text: this.translate.instant('COMMON.CANCEL'),
        });
      }

      const alert = await this.alertController.create({
        header,
        message,
        backdropDismiss: false,
        buttons,
        cssClass: 'confirm-cancel-alert',
      });
      await alert.present();
      return alert;
    }
  }

  async showAlertBuyActivationCode(buttonText: string): Promise<HTMLIonAlertElement> {
    const buttons = [
      { role: 'cancel', text: this.translate.instant('COMMON.CANCEL') },
      { role: 'confirm', text: this.translate.instant(buttonText) },
    ];
    const header = this.translate.instant('COMMON.CAUTION');
    const message = this.translate.instant('VIDEO_PLAY.TRIAL_EXPIRED');

    const alert = await this.alertController.create({
      header,
      message,
      buttons,
      backdropDismiss: false,
      cssClass: 'confirm-cancel-alert',
    });
    await alert.present();

    return alert;
  }
}
